import { JobDescription } from "./job-description";

export class Employee {
  private registration: string;
  private admissionDate: string;
  private jobDesciption: JobDescription;

  setRegistration(value: string): void {
    this.registration = value;
  }

  getRegistration(): string {
    return this.registration;
  }

  setAdmissionDate(value: string): void {
    this.admissionDate = value;
  }

  getAdmissionDate(): string {
    return this.admissionDate;
  }

  setJobDescription(value: JobDescription): void {
    this.jobDesciption = value;
  }

  getJobDescription(): JobDescription {
    return this.jobDesciption;
  }
}
